import { StyleSheet } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  bodySection: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginStart: -11,
  },
  bodySectionText: {
    marginStart: 14,
  },
  icon: {
    marginStart: 11.6,
  },
  bodyDescriptionStyle: {
    fontSize: 14.6,
    lineHeight: 18.8,
    color: Colors.light_grey,
  },
  bodySectionTopText: {
    fontSize: 18.7,
    color: Colors.dark_grey,
    lineHeight: 25,
  },
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});
